import { api } from './api'
import { RecordRelationship } from '../types'

/**
 * Record-access service — NOM-004 REQ-AUTH-02/04.
 * Surfaces the accessor's relationship to the patient and captures a
 * break-the-glass justification when access is outside a treating relationship.
 */
export const recordAccessService = {
  getRelationship: (patientId: string): Promise<RecordRelationship> => {
    return api.get<RecordRelationship>(`/record-access/${patientId}/relationship`)
  },

  breakTheGlass: (
    patientId: string,
    justification: string,
  ): Promise<{ status: string; logged: boolean }> => {
    return api.post(`/record-access/${patientId}/break-the-glass`, { justification })
  },
}
